import { Paper } from "@mui/material"
import { useSlideInContext } from "ui"
import { ADD_NOTE, MAKE_A_REFERRAL } from "ft-shared-components"
import { StudentNoteTable } from "./components/StudentNoteTable"
// import { ADD_NOTE, MAKE_A_REFERRAL } from "../components/SlideIn/contentTypes"
// import { useSlideInContext } from "../../context/SlideInContext"
import { useNavigate, useParams } from "react-router"
import usePersonAuthStore, { decodedToken } from "../store/personAuthStore"
import { useStudentContext } from "../../context/studentContext"
type StudentNoteTableProps = {
    onBack?: () => void
}
const StudentNoteTablePage = ({ onBack }: StudentNoteTableProps) => {
    const { handleContent } = useSlideInContext()
    const accessToken = usePersonAuthStore(state => state.access_token)
    const navigate = useNavigate()
    const { sid } = useParams();


    return (
        <Paper>
            <StudentNoteTable onBack={onBack}
                onAction={(action) => {
                    switch (action) {
                        case "REPORTS":
                            navigate(`/dashboard/student/${sid}/sessions`)
                            break;
                        case "NOTES":
                            handleContent(ADD_NOTE, {
                                studentId: sid
                            })
                            break;
                        case "REFERRAL":
                            handleContent(MAKE_A_REFERRAL, {
                                studentId: sid,
                            })
                            break;

                    }
                }}
            />
        </Paper>
    )
}

export default StudentNoteTablePage